An optional field for signalling hirer intent to post an ad via a channel other than Ad Sync eg. classic or Enhanced Job Posting.

Currently only one code is defined `Other`.

The inclusion of this field means that the position will not be posted to SEEK via Ad Sync.
